<template>
    <div class="flex min-h-screen flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <Logo v-if="isMobile" class="mx-auto [&>*>*]:mx-auto [&>*]:mx-auto" :width="300" :height="100" />
            <Logo v-else class="mx-auto [&>*>*]:mx-auto [&>*]:mx-auto" />
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import Logo from "@/craftable-pro/Components/Logo.vue";
import {onMounted} from "vue";
import {useSettings} from "@/hooks/useSettings";

const isMobile = window.innerWidth <= 768;

const {isProduction} = useSettings();
onMounted(() => {
    if (isProduction.value) {
        if (!document.getElementById('smartlook-script')) {
            const script = document.createElement('script');
            script.id = 'smartlook-script'; // Adiciona um ID para evitar duplicação
            script.type = 'text/javascript';
            script.innerHTML = `
                window.smartlook||(function(d) {
                    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
                    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
                    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
                })(document);
                smartlook('init', '29f9c1e0538d12e12a470c80467fd3bfd9bcd2c7', { region: 'eu' });
            `;
            document.head.appendChild(script);
        }
    }
});
</script>
